<template>
  <b-collapse :model-value="isOpen" class="card" animation="">
    <template #trigger="props">
      <div class="card-header">
        <p class="card-header-title"><span>{{ title }}</span> <span class="required" v-if="hasRequiredField"></span></p>
        <a class="card-header-icon"><b-icon :icon="props.open ? 'menu-down' : 'menu-up'"></b-icon></a>
      </div>
    </template>
    <div class="card-content">
      <div class="content">
        <slot></slot>
      </div>
    </div>
  </b-collapse>
</template>

<script>
export default {
  name: "PatientSection",
  props: {
    title: {
      type: String,
      required: true
    },
    hasRequiredField: {
      type: Boolean,
      default: false
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
  .card-header-title {
    font-weight: 500;
    font-size: 15px;
    .required {
      align-self: flex-start;
      margin-top: -4px;
      padding-left: 2px;
      &:after {
        content: "\f06c4";
        display: inline-block;
        color: hsl(348, 86%, 61%);
        font-family: "Material Design Icons";
        font-size: 8px;
      }
    }
  }
</style>